/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContentType
 */
export interface ContentType {
    /**
     * 
     * @type {number}
     * @memberof ContentType
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentType
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof ContentType
     */
    readonly appLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ContentType
     */
    readonly modelName: string;
}

/**
 * Check if a given object implements the ContentType interface.
 */
export function instanceOfContentType(value: object): value is ContentType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('appLabel' in value) || value['appLabel'] === undefined) return false;
    if (!('modelName' in value) || value['modelName'] === undefined) return false;
    return true;
}

export function ContentTypeFromJSON(json: any): ContentType {
    return ContentTypeFromJSONTyped(json, false);
}

export function ContentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'model': json['model'],
        'appLabel': json['app_label'],
        'modelName': json['model_name'],
    };
}

  export function ContentTypeToJSON(json: any): ContentType {
      return ContentTypeToJSONTyped(json, false);
  }

  export function ContentTypeToJSONTyped(value?: Omit<ContentType, 'id'|'app_label'|'model_name'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'model': value['model'],
    };
}

